import template from './dynamicLinkFormElement.html';
import controller from './dynamicLinkFormElement.controller';
import './dynamicLinkFormElement.scss';

let dynamicLinkFormElementComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    value: '=',
    name: '@',
    storeFile: '&',
    removeFile: '&',
    thumb: '<',
    type: '@',
    validationError: '<'
  },
  template,
  controller
};

export default dynamicLinkFormElementComponent;
